import React, { useEffect, useState } from "react";
import api from "@/auth/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { fetchCountryList } from "@/slices/LocationSlice/countrySlice";
import { useSelector, useDispatch } from "react-redux";
import { alertError, alertSuccess } from "@/components/Alert";

function SingleCountryOptionList({ rowData }) {

    // console.log(rowData)
  const editable = []
  const dispatch = useDispatch();
  const [addDis, setAddDis] = useState(false);
  const initialOptions = rowData?.countryOptionList || {};
  const optionList = rowData?.option_List || [];

  const [selectedOptions, setSelectedOptions] = useState({ ...initialOptions });
  const { countryList, status } = useSelector((state) => state.countryList);

  const [newCountry, setNewCountry] = useState("");

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCountryList());
    }
  }, [dispatch]);

  const handleCheckboxChange = (country, optionId) => {
    setSelectedOptions((prev) => {
      const current = prev[country] || [];
      const isSelected = current.includes(optionId);

      return {
        ...prev,
        [country]: isSelected
          ? current.filter((id) => id !== optionId)
          : [...current, optionId],
      };
    });
  };

  const handleSave = async () => {
    const finalData = {
      id: rowData.id,
      countryOptionList: selectedOptions,
    };
    try {
      const resp = await api.patch("/panel/PanelVariableMap", finalData);
      alertSuccess(resp?.data?.success);
      // console.log(resp);
    } catch (err) {
        alertError(err?.response?.data?.errors);
    }
  };

  const handleAddNewCountry = async () => {
    const selectedCountry = countryList?.result?.find(
      (c) => c?.title === newCountry
    );
    // console.log(selectedCountry)
    const finalData = {
        id: rowData.id,
        countryOptionList: {
            [selectedCountry?.title]:[]
        },
      };
      try {
        const resp = await api.patch("/panel/PanelVariableMap", finalData);
        alertSuccess(resp?.data?.success);
        // console.log(resp);
      } catch (err) {
          alertError(err?.response?.data?.errors);
      }

    
  };

  return (
    <>
      {!addDis ? (
  <div className={`max-w-2xl w-full mx-auto border p-1 rounded-xl`}>
          {Object.entries(initialOptions).map(([country]) => (
            <div key={country} className="mb-6 border">
              <strong className="block mb-4 text-lg font-bold text-gray-800 border-b pb-2">{country}</strong>

              {optionList.length === 0 ? (
                <p className="text-gray-500">There is no options yet</p>
              ) : (
                <ul className="flex flex-wrap gap-1" >
                  {optionList.map((option) => {
                    const inputId = `${country}-${option.id}`;
                    return (
                      <li
                        key={option.id}
                        className="flex items-center w-full sm:w-[30%] max-w-[220px] p-2 rounded-md hover:bg-gray-50 transition"
                        >
                        <input
                            id={inputId}
                            type="checkbox"
                            checked={(selectedOptions[country] || []).includes(option.id)}
                            onChange={() => handleCheckboxChange(country, option.id)}
                            className="w-4 h-4 accent-blue-600 cursor-pointer"
                        />

                        <label
                            htmlFor={inputId}
                            className="ml-2 text-sm font-medium text-gray-700 cursor-pointer truncate"
                        >
                            {option?.title}
                        </label>
                        </li>
                    );
                  })}
                </ul>
              )}
            </div>
          ))}

          {editable && 
          <>
            <button
            onClick={handleSave}
            className="mt-3 px-3 py-2 rounded-lg bg-green-600 text-white font-semibold shadow-md hover:bg-green-700 hover:shadow-lg transition-all text-sm"
            >
            Save Changes
            </button>

                <button
            onClick={() => setAddDis(true)}
            className="mt-3 px-3 py-2 rounded-lg bg-blue-600 text-white font-semibold shadow-md hover:bg-blue-700 hover:shadow-lg transition-all ml-3 text-sm"
            >
               Add New Country <FontAwesomeIcon icon={faAdd} className="ml-2" />
            </button>
          </>
          }

        </div>
      ) : (
        <div className="max-w-xl mx-auto border p-4 rounded">
          <h2 className="font-bold mb-4">Add New Country</h2>

          <div className="mb-4">
            {/* <label className="block mb-1 font-semibold">Select Country:</label> */}
            <select
              className="w-full border px-2 py-1 rounded"
              value={newCountry}
              onChange={(e) => setNewCountry(e.target.value)}
            >
              <option value="">-- Select Country --</option>
              {countryList?.result?.map((country) => (
                <option key={country?.id} value={country?.title}>
                  {country?.title}
                </option>
              ))}
            </select>
          </div>

          <div className="flex gap-2">
                <button
            onClick={handleAddNewCountry}
            className="px-3 py-2 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700 shadow transition text-xs"
            >
            Add Country
            </button>

            <button
            onClick={() => setAddDis(false)}
            className="px-3 py-2 rounded-lg bg-gray-200 text-gray-800 font-semibold hover:bg-gray-300 transition text-xs"
            >
            Back
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default SingleCountryOptionList;
